import { useCallback } from "react";
import toast from "react-hot-toast";
import { captureUserVisibleError } from "ui/lib/sentry";

/**
 * Shows a toast and reports to Sentry. Pass the original error (and a surface
 * identifier) so the report carries a stack and useful context — Sentry events
 * raised through this helper bypass the network-error filter.
 *
 * @example
 *   const { activateError } = useErrorNotification();
 *   try { ... } catch (error) {
 *     activateError(getApiErrorMessage(error, "Unable to save"), {
 *       error,
 *       surface: "members_status_save",
 *     });
 *   }
 */
export const useErrorNotification = () => {
  const activateError = useCallback((message, options) => {
    toast.error(message);
    if (options?.surface) {
      captureUserVisibleError(options.error ?? new Error(message), {
        surface: options.surface,
        extra: { displayMessage: message, ...options.extra },
      });
    }
  }, []);

  return {
    activateError,
  };
};
